import { Component, inject } from '@angular/core';
import { GasOilProviderService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GasOilProviderCreateDto,
  GasOilProviderDto,
  GasOilProviderExcelDownloadDto,
  GasOilProviderUpdateDto,
} from '../proxy/general/dtos/gas-oil-provider';
import { GASOILPROVIDER_CONFIG, GASOILPROVIDER_FIELDS } from './gas-oil-provider.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-gas-oil-provider',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GasOilProviderService, ConfirmationService],
  templateUrl: './gas-oil-provider.html',
  styleUrl: './gas-oil-provider.scss',
})
export class GasOilProvider extends BaseCrudComponent<
  GasOilProviderDto,
  GasOilProviderCreateDto,
  GasOilProviderUpdateDto,
  GasOilProviderExcelDownloadDto
> {
  service = inject(GasOilProviderService);
  config = GASOILPROVIDER_CONFIG;
  fields = GASOILPROVIDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: GasOilProviderDto): GasOilProviderUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      oldSapCode: data.oldSapCode,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GasOilProvider';
  }
}
